// Real Time Table suggestive word/key
export const dynamicRows = ['status']
export const realTimeTableKey = 'GetDataByUser'

export const dynamicColumns = [{
    prop: 'online_user_id',
    fixed: false,
    align: 'center',
    label: 'Online User ID',
}, {
    prop: 'representant',
    fixed: false,
    align: 'center',
    label: 'Representant',
}, {
    prop: 'user_name',
    fixed: false,
    align: 'center',
    label: 'User Name',
}, {
    prop: 'extension_name',
    fixed: false,
    align: 'center',
    label: 'Extension Name',
}, {
    prop: 'extension_id',
    fixed: false,
    align: 'center',
    label: 'Number',
}, {
    prop: 'status',
    fixed: false,
    align: 'center',
    label: 'Status',
}, {
    prop: 'status_duration',
    fixed: false,
    align: 'center',
    label: 'Current Status Duration',
    width: '250px',
}, {
    prop: 'caller_info',
    fixed: false,
    align: 'center',
    label: 'Caller Info',
    sortable: false,
}, {
    prop: 'call_info',
    fixed: false,
    align: 'center',
    label: 'Call Info',
    sortable: false,
}]
